import InputGroupAddon, { propsFactory } from './input-group-addon';

export default {
  functional: true,
  props: propsFactory(false),
  render: InputGroupAddon.render
};


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/input-group/input-group-prepend.js
// module id = gMle
// module chunks = 1